import {
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import fullSchema from '../../schema';
import { POW_ERA_LABELS } from '../../constants';

// Section V Item 13 — POW era/campaign. Only reached when the Veteran answered
// "yes" on the POW page (page-level `depends` in the form config). Continue
// leads to the POW dates page.
export default {
  uiSchema: {
    ...titleUI('POW eras or campaigns'),
    powEraCampaign: radioUI({
      title: 'Select the era or campaign during which you were a POW',
      labels: POW_ERA_LABELS,
      errorMessages: {
        required: 'Select the era or campaign during which you were a POW',
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['powEraCampaign'],
    properties: {
      powEraCampaign: fullSchema.properties.powEraCampaign,
    },
  },
};
